export default function CompanyLogo({ company, size = "md" }) {
    if (!company) return null;
    const parts = company.name.split(" ");
    const initials = parts.slice(0, 2).map((p) => p[0]).join("").toUpperCase();
    const sizes = {
        sm: "w-8 h-8 text-xs",
        md: "w-10 h-10 text-sm",
        lg: "w-14 h-14 text-base",
    };
    return (
        <div
            className={`${sizes[size]} shrink-0 flex items-center justify-center font-heading font-extrabold tracking-tighter rounded-sm border`}
            style={{ borderColor: company.color, color: company.color, backgroundColor: "#FFFFFF" }}
            data-testid={`company-logo-${company.slug}`}
        >
            {initials}
        </div>
    );
}
